import { queryString } from '@opallabs/api/src/httpClient/queryString'
import { HttpClient } from '../../../httpClient'
import { type OpalApi, type ValidatedOperationId } from '../../../schema'
import { OperationIds } from '../../../util'
import { BlockConnectorCandidatesResponse } from '../types'

type ReadBlockConnectorCandidatesOperationId =
  ValidatedOperationId<OperationIds.ReadBlockConnectorCandidatesBFFV1>
type ReadBlockConnectorCandidatesRequest = OpalApi<
  ReadBlockConnectorCandidatesOperationId,
  200
>

export const readBlockConnectorCandidates: ReadBlockConnectorCandidatesRequest =
  ({ params }: Parameters<ReadBlockConnectorCandidatesRequest>[0] = {}) => {
    if (!params || !params.path.workspace_id) {
      throw new Error(
        'readBlockConnectorCandidates must be provided with params.path.workspace_id'
      )
    }
    if (!params || !params.path.block_id) {
      throw new Error(
        'readBlockConnectorCandidates must be provided with params.path.block_id'
      )
    }
    const url = new URL(
      `/asgard-bff/${params.path.workspace_id}/blocks/${params.path.block_id}/connector_candidates`,
      window.location.origin
    )

    url.search = queryString(
      params?.query.all_blocks
        ? { all_blocks: params.query.all_blocks.toString() }
        : undefined
    )

    return HttpClient()
      .get<BlockConnectorCandidatesResponse>(url.toString())
      .then((res) => res.data)
  }
